import {type CSSProperties, type Ref} from "react";
import classNames from "classnames";

import {IIcon} from "../types/IIcon";
import {SvgIconWrapper} from "./SvgIconWrapper";

import {svgIconBase} from "./SvgIcon.module.css";

interface IProps extends IIcon {
    ref?: Ref<HTMLDivElement>;
}

export const SvgIcon = (props: IProps) => {
    const {ref, children, fill, size, className, onClick, dataTestid, wrapperSize, wrapperColor, wrapperType, "aria-label": ariaLabel, viewBox} = props;

    const hasWrapper = wrapperSize && wrapperColor;
    const iconStyle = {
        "--iconFill": fill || "var(--colors-secondary)",
        "--iconSize": size || "1"
    } as CSSProperties;
    const svgIconCN = classNames(svgIconBase, className);

    const icon = (
        <svg
            onClick={!hasWrapper ? onClick : undefined}
            className={!hasWrapper ? svgIconCN : svgIconBase}
            style={iconStyle}
            viewBox={viewBox || "0 0 10 10"}
            data-testid={dataTestid}
            aria-label={ariaLabel}
        >
            {children}
        </svg>
    );
    return wrapperSize && wrapperColor ? (
        <SvgIconWrapper onClick={onClick} wrapperColor={wrapperColor} wrapperSize={wrapperSize} wrapperType={wrapperType} className={className} ref={ref}>
            {icon}
        </SvgIconWrapper>
    ) : (
        icon
    );
};
import {type CSSProperties, type Ref} from "react";
import classNames from "classnames";

import {IIcon} from "../types/IIcon";
import {SvgIconWrapper} from "./SvgIconWrapper";

import {svgIconBase} from "./SvgIcon.module.css";

interface IProps extends IIcon {
    ref?: Ref<HTMLDivElement>;
}

export const SvgIcon = (props: IProps) => {
    const {ref, children, fill, size, className, onClick, dataTestid, wrapperSize, wrapperColor, wrapperType, "aria-label": ariaLabel, viewBox} = props;

    const hasWrapper = wrapperSize && wrapperColor;
    const iconStyle = {
        "--iconFill": fill || "var(--colors-secondary)",
        "--iconSize": size || "1"
    } as CSSProperties;
    const svgIconCN = classNames(svgIconBase, className);

    const icon = (
        <svg
            onClick={!hasWrapper ? onClick : undefined}
            className={!hasWrapper ? svgIconCN : svgIconBase}
            style={iconStyle}
            viewBox={viewBox || "0 0 10 10"}
            data-testid={dataTestid}
            aria-label={ariaLabel}
        >
            {children}
        </svg>
    );
    return wrapperSize && wrapperColor ? (
        <SvgIconWrapper onClick={onClick} wrapperColor={wrapperColor} wrapperSize={wrapperSize} wrapperType={wrapperType} className={className} ref={ref}>
            {icon}
        </SvgIconWrapper>
    ) : (
        icon
    );
};
